import { render } from "./addDealerForm.vue?vue&type=template&id=94f0a3fc&scoped=true"
import script from "./addDealerForm.vue?vue&type=script&lang=js"
export * from "./addDealerForm.vue?vue&type=script&lang=js"

import "./addDealerForm.vue?vue&type=style&index=0&id=94f0a3fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94f0a3fc"]])

export default __exports__